import styled from 'styled-components'

export const BackButtonText = styled.span<{
  color: string
  $extraMargin: boolean
}>`
  display: block;
  text-align: center;
  color: ${({ color }) => color || '#fff'};
  align-self: center;
  padding: 0 1.5em;
  margin: 0 auto 1.5em;
  margin-top: ${({ $extraMargin }) => ($extraMargin ? '1.5em' : '0')};
  font-family: 'ProximaNova-Regular', proxima-nova, 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
`

/**
 * OB-499: Native <button> replaces TouchableOpacity. Used when the
 * back action triggers a programmatic history.go / dispatch chain.
 *
 * align-self: center centers the button when its parent is a flex
 * container (true on every BackButton consumer page).
 */
export const BackButtonAction = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  width: fit-content;
  align-self: center;
`

/**
 * OB-499: Native <a> replaces react-router-dom <Link>. Used when the
 * back action navigates to a known path. onClick handles SPA routing
 * via history.push; href is preserved for accessibility / new-tab.
 */
export const BackButtonLink = styled.a`
  text-decoration: none;
  width: fit-content;
  align-self: center;
`
